import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4b8618b2")
const _hoisted_1 = { class: "container m-4 " }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoucherSelectComponent = _resolveComponent("VoucherSelectComponent")!
  const _component_CategoryComponent = _resolveComponent("CategoryComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VoucherSelectComponent, {
      key: 'voucher_component' + _ctx.$i18n.locale,
      "selected-voucher-type": $props.voucherType,
      class: "is-inline-flex is-hidden flex",
      onChange: $setup.onChangeVoucherType
    }, null, 8, ["selected-voucher-type", "onChange"]),
    _createVNode(_component_CategoryComponent, {
      key: 'voucher_component' + _ctx.$i18n.locale + $props.voucherType,
      "selected-voucher-type": $props.voucherType,
      "selected-category": $props.category,
      class: "is-inline-flex ",
      onChange: $setup.onChangeCategory
    }, null, 8, ["selected-voucher-type", "selected-category", "onChange"])
  ]))
}